import React from 'react'
import PropTypes from 'prop-types'

const Header = (props) => {
  return (
    <header className='catalog-form-header clearfix mb-4'>
      <div className='float-start mb-4 h4'>{props.wording.headline}&nbsp;
        <small className='d-block'>{props.wording.subline}</small>
      </div>
      {props.logoUrl && (
          <img
            alt={props.organisationName + '-logo'}
            src={props.logoUrl}
            width={100}
            className='organisation-logo float-end ms-5 mt-4'
          />
      )}
      <div style={{ clear: 'left' }}>
        {props.wording.teaser}
      </div>
    </header>
  )
}

Header.propTypes = {
  wording: PropTypes.shape({
    headline: PropTypes.string,
    subline: PropTypes.string,
    teaser: PropTypes.element,
  }).isRequired,
  /**
   * logoUrl and organisationName only relevant for initial_order
   * **/
  logoUrl: PropTypes.string,
  organisationName: PropTypes.string
}

export default Header
